"use client";

import { useEffect, useState } from "react";

export enum StorageKey {
  Referral = "referral",
}

export const useLocalStorage = <T>(key: StorageKey) => {
  const [value, setValue] = useState<T | null>(() => {
    if (typeof window === "undefined") return null;
    const saved = localStorage.getItem(key);
    return saved && JSON.parse(saved);
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return {
    value,
    setValue,
  };
};
